import {
  PaginationResultsEmployeeTableDataDto,
  BulkEditEmployeesProfilesRequest,
  BulkEditEmployeesLabelsRequest,
  BulkDeleteEmployeesRequest,
  CompanyPolicyMiniResponse,
  ImportSummaryResponse,
  EditEmployeeRequest,
  AddEmployeeRequest,
  SearchRequest,
  ServiceType,
} from '@interfaces/models';
import { httpClient } from '@api/interceptors';
import qs from 'qs';

export async function getPaginatedEmployees(
  request: SearchRequest,
): Promise<PaginationResultsEmployeeTableDataDto> {
  return httpClient
    .get('employees', {
      searchParams: qs.stringify(request, { allowDots: true }),
    })
    .json();
}

export async function removeEmployee(employeeId: string): Promise<void> {
  return httpClient.delete(`employees/${employeeId}`).json();
}

export async function addEmployee(employee: AddEmployeeRequest): Promise<void> {
  return httpClient.post('employees', { json: employee }).json();
}

export async function editEmployee(employee: EditEmployeeRequest, id: string): Promise<void> {
  return httpClient.put(`employees/${id}`, { json: { ...employee, id } }).json();
}

export async function bulkEditEmployeeProfiles({
  employeeIds,
  profiles,
}: BulkEditEmployeesProfilesRequest): Promise<void> {
  return httpClient.put('employees/bulk-profiles', { json: { employeeIds, profiles } }).json();
}

export async function bulkEditEmployeeLabels({
  employeeIds,
  labels,
}: BulkEditEmployeesLabelsRequest): Promise<void> {
  return httpClient.put('employees/bulk-labels', { json: { employeeIds, labels } }).json();
}

export async function bulkEditEmployeeDelete({
  employeeIds,
}: BulkDeleteEmployeesRequest): Promise<void> {
  return httpClient.put('employees/bulk-delete', { json: { employeeIds } }).json();
}

export async function getEmployeeFiltersServices(): Promise<ServiceType[]> {
  return httpClient.get(`employees/filter/services`).json();
}

export async function getEmployeeFiltersProfiles(): Promise<CompanyPolicyMiniResponse[]> {
  return httpClient.get(`employees/filter/profiles`).json();
}

export const getEmployeeImportSummary = async (file: File): Promise<ImportSummaryResponse> => {
  const formData = new FormData();
  formData.append('file', file);

  return httpClient.post('employees/import-summary', { body: formData, timeout: 180000 }).json();
};

export const getEmployeeImportErrorFile = async (): Promise<Blob> => {
  return httpClient.get('employees/import-errors', { timeout: 180000 }).blob();
};

export const saveEmployeesImport = async (): Promise<void> => {
  return await httpClient.post('employees/import-bulk', { timeout: 180000 }).json();
};

export const assignEmployeeProfiles = async (
  employeeId: string,
  employeeProfiles: string[],
): Promise<void> => {
  return await httpClient
    .put(`employees/${employeeId}/profiles`, { json: { employeeProfiles } })
    .json();
};

export async function getAssignEmployees(
  request: { ids: string[] } & SearchRequest,
): Promise<PaginationResultsEmployeeTableDataDto> {
  return await httpClient.post(`employees/assigned`, { json: request }).json();
}

export async function getEmployees(
  request: SearchRequest,
): Promise<PaginationResultsEmployeeTableDataDto> {
  return await httpClient
    .get(`employees/assign`, { searchParams: qs.stringify(request, { allowDots: true }) })
    .json();
}
